import './TagList.scss';
import React, { useState } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import Tag from '../tag/Tag';

type TagProps = {
    className?: string;
    children: React.ReactNode[];
};

const TagList: React.FC<TagProps> & { Tag: React.ElementType } = ({
    className,
    children
}) => {
    const { t } = useTranslation();

    const limit = 5;
    const [isShowingAll, setIsShowingAll] = useState(false);
    const firstTen = React.Children.toArray(children).slice(0, limit);

    const handleShowAllClick = () => setIsShowingAll(!isShowingAll);

    return (
        <div className={cx('b-tag-list', className)}>
            {isShowingAll ? children : firstTen}
            {!isShowingAll && (
                <div className="b-tag-list__teaser-element-container">
                    {children[limit]}
                </div>
            )}
            {children.length > limit && (
                <span
                    className="b-tag-list__show-all-button"
                    onClick={handleShowAllClick}
                    role="button"
                    title="tag-list-show-all-button"
                    style={{
                        marginLeft: isShowingAll ? '8px' : '-20px',
                        zIndex: 0
                    }}
                >
                    {isShowingAll ? t('show_less') : t('show_all')}
                </span>
            )}
        </div>
    );
};

TagList.Tag = Tag;

export default TagList;
